var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgStar = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.092 1.969a1 1 0 0 1 1.816 0L13.87 6.22a1 1 0 0 0 .79.574l4.65.552a1 1 0 0 1 .56 1.727l-3.436 3.179a1 1 0 0 0-.302.929l.912 4.592a1 1 0 0 1-1.47 1.067l-4.085-2.287a1 1 0 0 0-.976 0L6.426 18.84a1 1 0 0 1-1.47-1.067l.913-4.592a1 1 0 0 0-.302-.93L2.13 9.074a1 1 0 0 1 .561-1.727l4.65-.552a1 1 0 0 0 .79-.574l1.96-4.251Z"
  })));
});
SvgStar.displayName = "SvgStar";
export default SvgStar;